import { storeService } from '../../helpers/services/store.service'
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
  stores: { data: [] },
  status: { list: true, save: true },
}

export const STORE_MODULE = 'store'

export const GET_ALL_STORES = 'getAllStores'
export const CREATE_STORE = 'createStore'
export const UPDATE_STORE = 'updateStore'
export const DELETE_STORE = 'deleteStore'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const STORES_SUCCESS = 'storesSuccess'

function mapStore(item) {
  return {
    uuid: item.uuid,
    name: item.name,
    storeType: item.store_type,
    debtorCode: item.debtor_code,
    address: item.address,
    city: item.city,
    state: item.state,
    postcode: item.postcode,
    phone: item.phone,
    email: item.email,
    latitude: item.latitude,
    longitude: item.longitude,
    mapUrl: item.map_url,
    operatingHours: item.operating_hours,
    displayOrder: item.display_order,
    isActive: item.is_active,
  }
}

export const actions = {
  [GET_ALL_STORES]({ commit }, filter = {}) {
    commit(REQUESTING, 'list')
    return storeService.getAll(filter).then((r) => {
      commit(STORES_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [CREATE_STORE]({ commit, dispatch }, { data }) {
    commit(REQUESTING, 'save')
    return storeService.create(data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.createX', [i18n.t('module.store')]))
      commit(SUCCESS); dispatch(GET_ALL_STORES); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [UPDATE_STORE]({ commit, dispatch }, { uuid, data }) {
    commit(REQUESTING, 'save')
    return storeService.update(uuid, data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.store')]))
      commit(SUCCESS); dispatch(GET_ALL_STORES); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [DELETE_STORE]({ commit, dispatch }, { uuid }) {
    return storeService.remove(uuid).then((r) => {
      commit(SUCCESS); dispatch(GET_ALL_STORES); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
}

export const mutations = {
  [STORES_SUCCESS](state, data) { state.stores.data = (data.data || []).map(mapStore) },
  [FAILURE](state) { state.status = { list: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, save: true } },
}
